import { useState, useEffect } from "react";
import jwtDecode from 'jwt-decode';
import { Menu, ProSidebar, MenuItem, } from "react-pro-sidebar";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { tokens } from "../../theme";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import ContactsOutlinedIcon from "@mui/icons-material/ContactsOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import PieChartOutlineOutlinedIcon from "@mui/icons-material/PieChartOutlineOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import AddTaskIcon from '@mui/icons-material/AddTask';
import PreviewIcon from '@mui/icons-material/Preview';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import PetsIcon from '@mui/icons-material/Pets';
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import ListAltIcon from '@mui/icons-material/ListAlt';
import pf1 from "../../assets/images/random-profiles/pf1.jpg";
import pf2 from "../../assets/images/random-profiles/pf2.jpg";
import pf3 from "../../assets/images/random-profiles/pf3.jpg";
import pf4 from "../../assets/images/random-profiles/pf4.jpg";

const Item = ({ title, to, icon, selected, setSelected, disabled }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const handleClick = () => {
    if (!disabled) {
      setSelected(title);
    }
  };

  return (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.grey[100],
        pointerEvents: disabled ? 'none' : 'auto',
        opacity: disabled ? 0.5 : 1,
      }}
      onClick={handleClick}
      icon={icon}
    >
      <Typography>{title}</Typography>
      {disabled ? null : <Link to={to} />}
    </MenuItem>
  );
};


const Sidebar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [selected, setSelected] = useState("Dashboard");
  const [medicalOpen, setMedicalOpen] = useState(false);

  const handleMedicalClick = () => {
    setMedicalOpen(!medicalOpen);
  };

  // For API
  const [currentUser, setCurrentUser] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);

  const getCurrentUser = () => {
    const token = localStorage.getItem('token');
    const decoded = jwtDecode(token);
    setCurrentUser(decoded);
    if (decoded.username === "Admin" || decoded.username === "Super Admin") {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
    }
  }

  useEffect(()=> {
    getCurrentUser()
  },[])
  const [imageUrl, setImageUrl] = useState('');
  useEffect(() => {
    // List of image URLs
    const imageList = [
      pf1,
      pf2,
      pf3,
      pf4,
      // Add more image URLs as needed
    ];

    // Generate a random index
    const randomIndex = Math.floor(Math.random() * imageList.length);

    // Set the random image URL
    setImageUrl(imageList[randomIndex]);
  }, []);

  return (
    <Box
      sx={{
        // overflow: "auto",
        height: "100vh",
       scrollBehavior: "smooth",
       
        "& .pro-sidebar-inner": {
          background: `${colors.primary[400]} !important`,
        },
        "& .pro-icon-wrapper": {
          backgroundColor: "transparent !important",
        },
        "& .pro-inner-item": {
          padding: "5px 35px 5px 20px !important",
        },
        "& .pro-inner-item:hover": {
          color: "#868dfb !important",
        },
        "& .pro-menu-item.active": {
          color: "#6870fa !important",
        },
      }}
    >
      <ProSidebar collapsed={isCollapsed}>
        <Menu iconShape="square">
          {/* LOGO AND MENU ICON */}
          <MenuItem
            onClick={() => setIsCollapsed(!isCollapsed)}
            icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
            style={{
              margin: "10px 0 20px 0",
              color: colors.grey[100],
            }}
          >
            {!isCollapsed && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                ml="15px"
              >
                <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                  <MenuOutlinedIcon />
                </IconButton>
              </Box>
            )}
          </MenuItem>

          {!isCollapsed && (
            <Box mb="25px">
              <Box display="flex" justifyContent="center" alignItems="center">
                <img
                  alt="profile-user"
                  width="100px"
                  height="100px"
                  src={imageUrl}
                  
                  style={{ cursor: "pointer", borderRadius: "50%" }}
                />
              </Box>
              <Box textAlign="center">
                <Typography
                  variant="h2"
                  color={colors.grey[100]}
                  fontWeight="bold"
                  sx={{ m: "10px 0 0 0" }}
                >
                 {currentUser.username}
                </Typography>
                <Typography variant="h5" color={colors.greenAccent[500]}>
                  {isAdmin ? "ADMIN" : "USER"}
                </Typography>
              </Box>
            </Box>
          )}

          <Box paddingLeft={isCollapsed ? undefined : "10%"}>
            <Item
              title="Dashboard"
              to="/dashboard"
              icon={<HomeOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />

            {isAdmin &&<Typography
              variant="h6"
              color={colors.grey[300]}
              sx={{ m: "15px 0 5px 20px" }}
            >
              Data
            </Typography>}
          <Item
              title="Employee Information"
              to="/dashboard/team"
              icon={<PeopleOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            {isAdmin && <Item
              title="Admin Information"
              to="/dashboard/contacts"
              icon={<ContactsOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />}
          
              {isAdmin && 
            <Typography
              variant="h6"
              color={colors.grey[300]}
              sx={{ m: "15px 0 5px 20px" }}
            >
              Pages
            </Typography>}
            {isAdmin && <Item
              title="User Form"
              to="/dashboard/form"
              icon={<PersonOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />}
            {isAdmin &&
            <Item
              title="Admin Form"
              to="/dashboard/adminForm"
              icon={<AdminPanelSettingsIcon />}
              selected={selected}
              setSelected={setSelected}
            />}
           

            <Typography
              variant="h6"
              color={colors.grey[300]}
              sx={{ m: "15px 0 5px 20px" }}
            >
              Analytics
            </Typography>
            <Item
              title="Bar Chart"
              to="/dashboard/bar"
              icon={<BarChartOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Pie Chart"
              to="/dashboard/pie"
              icon={<PieChartOutlineOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Line Chart"
              to="/dashboard/line"
              icon={<TimelineOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
          
             <Typography
              variant="h6"
              color={colors.grey[300]}
              sx={{ m: "15px 0 5px 20px" }}
            >
              Inventory
            </Typography>
            <Item
              title="Inventory"
              to="inventory1"
              icon={<Inventory2OutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            
            <Typography
              variant="h6"
              color={colors.grey[300]}
              sx={{ m: "15px 0 5px 20px" }}
            >
             Task
            </Typography>
            <Item
              title="Task Records"
              to="/dashboard/task"
              icon={<AddTaskIcon />}
              selected={selected}
              setSelected={setSelected}
            />
              <Item
              title="Task History"
              to="/dashboard/task-history"
              icon={<ListAltIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            
             <Typography
              variant="h6"
              color={colors.grey[300]}
              sx={{ m: "15px 0 5px 20px" }}
            >
             Reports
            </Typography>
            <Item
              title="Observation Report"
              to="/dashboard/observation"
              icon={<PreviewIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Mortality Report"
              to="/dashboard/mortality"
              icon={<MonitorHeartIcon />}
              selected={selected}
              setSelected={setSelected}
            />
             <Typography
              variant="h6"
              color={colors.grey[300]}
              sx={{ m: "15px 0 5px 20px" }}
            >
            Records
            </Typography>
            <Item
              title="Animal Details"
              to="/dashboard/animal"
              icon={<PetsIcon />}
              selected={selected}
              setSelected={setSelected}
            />
             <Item
              title="Medical Records"
              to="/dashboard/medical"
              icon={<MedicalInformationIcon />}
              selected={selected}
              setSelected={setSelected}
            />
             <Item
              title="Medical History"
              to="/dashboard/view-medical-history"
              icon={<WorkHistoryIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            
           

              {/* ... */}
          </Box>
        </Menu>
      </ProSidebar>
    </Box>
  );
};

export default Sidebar;